/**
 * Created by lihanying on 2017/6/23.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Binding from './component/binding'
import './component/style.css'

class Bindings extends React.Component {
  render() {
    return (
      <div className="binding">
        <Binding
          fetchSendVerifyCode={this.props.fetchSendVerifyCode}
          fetchBinding={this.props.fetchBinding}
          fetRegionList={this.props.fetRegionList}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {}
}
export default withRouter(connect(mapStateToProps, actions)(Bindings))



// WEBPACK FOOTER //
// ./src/containers/Binding/index.js